export const e2lt = {
  meta: {
    title: 'Vandens nuotėkių aptikimas draudimui | E2 Insurance',
    description: 'E2 Insurance padeda draudikams anksčiau aptikti vandens nuotėkius, greičiau imtis veiksmų ir sumažinti vandens padarytos žalos mastą pasitelkiant sujungtą rizikos prevenciją.',
    twitterDescription: 'Sujungta rizikos prevencija moderniems draudikams. Aptikite anksčiau, reaguokite greičiau, sumažinkite žalos mastą.',
  },
  hero: {
    badge: 'E2 Insurance — Sujungta rizikos prevencija',
    h1: 'Užkirskite kelią vandens žalai, kol ji netapo didele draudimo išmoka.',
    sub: 'E2 Insurance padeda draudikams anksti aptikti vandens nuotėkius, akimirksniu įspėti reikiamus žmones ir sumažinti vandens sukeltų incidentų poveikį.',
    supporting: 'Nuo žalų administravimo prie aktyvios rizikos prevencijos.',
    ctaPrimary: 'Susipažinkite su E2 Insurance',
    ctaSecondary: 'Susisiekite su mumis',
    trustLine: 'Sukurta draudikams, pagalbos operatoriams ir moderniems būsto draudimo produktams.',
    liveLabel: 'Aktyvus incidentas',
    resolved: 'IŠSPRĘSTA',
    incidentTitle: 'Aptiktas vanduo — Virtuvė',
    incidentLoc: 'Ryga · Butas 4B',
    steps: [
      ['02:14', 'Aptiktas vanduo po virtuvės kriaukle'],
      ['02:15', 'Klientas informuotas'],
      ['02:17', 'Klientas patvirtino įspėjimą'],
      ['02:46', 'Incidentas išspręstas'],
    ],
    tta: 'Patvirtinimo laikas',
    ttaVal: '3 min',
    ttr: 'Išsprendimo laikas',
    ttrVal: '32 min',
  },
  problem: {
    label: 'Problema',
    h2: 'Vandens žala tampa brangi, kai niekas nežino, kad ji vyksta.',
    p1: 'Nedidelis nuotėkis gali likti nepastebėtas valandas ar dienas. Kol draudėjas jį pastebi, žala jau gali apimti grindis, sienas, baldus, kaimyninius būstus ir dideles atstatymo išlaidas.',
    p2: 'Tradicinis draudimas prasideda, kai pranešama apie žalą.',
    highlight: 'E2 Insurance prasideda tada, kai prasideda incidentas.',
    statement: 'Brangiausias nuotėkis — tas, apie kurį niekas nežino.',
  },
  compare: {
    label: 'Skirtumas',
    h2: 'Laikas keičia rezultatą.',
    withoutTitle: 'Be ankstyvo aptikimo',
    withoutSteps: ['Prasideda nuotėkis', 'Nuotėkis lieka nepastebėtas', 'Vandens žala plinta', 'Klientas pastebi žalą', 'Pranešama apie žalą', 'Prasideda atstatymo darbai'],
    withoutNote: 'Gali praeiti valandos ar dienos, kol kas nors sureaguoja.',
    withTitle: 'Su E2 Insurance',
    withSteps: ['Prasideda nuotėkis', 'Aptiktas vanduo', 'Klientas įspėtas', 'Incidentas patvirtintas', 'Imtasi veiksmų', 'Žala galimai apribota'],
    withNote: 'Minutės nuo aptikimo iki veiksmų.',
    conclusion: 'E2 paverčia laiką rizikos mažinimo įrankiu.',
  },
  value: {
    label: 'Kaip tai veikia',
    h2: 'Aptikite anksčiau. Reaguokite greičiau. Sumažinkite žalą.',
    stepLabel: 'Žingsnis',
    steps: [
      { title: 'Aptikti', desc: 'Vanduo identifikuojamas iškart, kai įvyksta incidentas.' },
      { title: 'Įspėti', desc: 'Reikiami žmonės informuojami automatiškai.' },
      { title: 'Reaguoti', desc: 'Draudėjas, pagalbos teikėjas ar priežiūros komanda gali greitai įsikišti.' },
      { title: 'Dokumentuoti', desc: 'Kiekvienas incidentas ir veiksmas gali būti registruojamas operatyvinei stebėsenai ir analizei.' },
    ],
  },
  metrics: {
    label: 'Išmatuojama prevencija',
    h2: 'Matuokite prevenciją reagavimo laiku.',
    items: [
      { label: 'Aptikimo laikas', desc: 'Kaip greitai incidentas identifikuojamas.' },
      { label: 'Patvirtinimo laikas', desc: 'Kaip greitai kas nors patvirtina įspėjimą.' },
      { label: 'Išsprendimo laikas', desc: 'Kaip greitai situacija suvaldoma.' },
    ],
    statement: 'Prevencija tampa išmatuojama, kai kiekvienas incidentas turi laiko juostą.',
  },
  gains: {
    label: 'Vertė draudimui',
    h2: 'Paverskite prevenciją išmatuojama draudimo verte.',
    items: [
      { title: 'Sumažinkite žalos mastą', desc: 'Ankstesnis aptikimas gali apriboti žalos apimtį iki įsikišimo.' },
      { title: 'Sutrumpinkite reagavimo laiką', desc: 'Įspėjimai generuojami automatiškai, o ne tikintis, kad kas nors problemą galiausiai pastebės.' },
      { title: 'Pagerinkite klientų patirtį', desc: 'Draudikas padeda klientams išvengti žalos, o ne tik ją kompensuoja vėliau.' },
      { title: 'Kurkite panaudojamus rizikos duomenis', desc: 'Gaukite struktūruotą informaciją apie incidentus, reagavimo laikus ir prevencijos rezultatus.' },
      { title: 'Stiprinkite klientų lojalumą', desc: 'Rizikos prevencijos paslaugos gali tapti apčiuopiamu būsto draudimo produktų privalumu.' },
      { title: 'Išskirkite savo produktus', desc: 'Pasiūlykite klientams proaktyvią paslaugą, pranokstančią tradicinę draudimo apsaugą ir kainą.' },
    ],
  },
  incident: {
    label: 'Incidentų atsekamumas',
    h2: 'Nuo incidento iki išsprendimo — matoma kiekviena sekundė.',
    sub: 'Kiekvienas incidentas sukuria išsamią, laiko žymomis pažymėtą įvykių istoriją — nuo pirmo aptikimo iki galutinio išsprendimo.',
    cardTitle: 'Aptiktas vanduo — Virtuvė',
    cardId: 'Incidentas #2481 · Pavyzdinis įvykis',
    status: 'Išspręsta',
    events: [
      ['02:14', 'Aptiktas vanduo po virtuvės kriaukle'],
      ['02:15', 'Klientas informuotas'],
      ['02:17', 'Klientas patvirtino įspėjimą'],
      ['02:21', 'Susisiekta su pagalbos tarnyba'],
      ['02:29', 'Pradėti veiksmai'],
      ['02:46', 'Incidentas išspręstas'],
    ],
    tta: 'Patvirtinimo laikas',
    ttaVal: '3 min',
    ttr: 'Išsprendimo laikas',
    ttrVal: '32 min',
    note: 'Konceptualus pavyzdys iliustracijai — ne reali veiklos statistika.',
  },
  customer: {
    label: 'Klientų patirtis',
    h2: 'Apsauga be sudėtingumo.',
    p1: 'E2 Insurance sukurtas veikti automatiškai fone. Draudėjui nereikia suprasti ar stebėti techninės infrastruktūros.',
    p2: 'Kai kažkas įvyksta, klientas gauna paprastą, aiškų įspėjimą su rekomenduojamais veiksmais.',
    e2homeSub: 'Paprasta apsauga draudėjui.',
    features: [
      'Būsto apsaugos būsena',
      'Aktyvūs įspėjimai',
      'Aptiktų incidentų vieta',
      'Push pranešimai',
      'Incidento patvirtinimas',
      'Paprastos instrukcijos',
      'Incidentų istorija',
      'Susisiekimas su pagalba',
      'Patvirtinimas, kai incidentas išspręstas',
    ],
    highlight: 'Programėlė egzistuoja dėl vienos priežasties: padėti klientui greitai veikti, kai kažkas įvyksta.',
    mockup: {
      homeStatus: 'Namų būsena',
      protected: 'Apsaugota',
      alertTitle: 'Aptiktas vanduo',
      alertLoc: 'Virtuvė · Po kriaukle · 14:32',
      recommended: 'Rekomenduojamas veiksmas',
      recommendedAction: 'Nedelsdami patikrinkite vietą.',
      btnCheck: 'Tikrinu',
      btnAssist: 'Susisiekti su pagalba',
    },
  },
  control: {
    label: 'Draudikui',
    h2: 'Vienas vaizdas per visą apdraustą portfelį.',
    sub: 'E2 Insurance Control Center suteikia operacinėms komandoms realaus laiko matomumą į kiekvieną apsaugotą būstą ir kiekvieną aktyvų incidentą.',
    sampleTag: 'PAVYZDINĖ SĄSAJA — ILIUSTRACINĖS REIKŠMĖS',
    kpis: [
      { label: 'Apsaugoti būstai', value: '12 482' },
      { label: 'Aktyvūs incidentai', value: '7' },
      { label: 'Vidutinis patvirtinimo laikas', value: '2 min 18 s' },
      { label: 'Šį mėnesį išspręsti incidentai', value: '164' },
    ],
    tableHeaders: ['Būstas', 'Incidento tipas', 'Vieta', 'Aptikta', 'Patvirtinta', 'Pagalba', 'Būsena'],
    incidents: [
      { property: 'Ryga – Butas 4B', type: 'Aptiktas vanduo', location: 'Virtuvė', detected: '08:42', ack: '08:45', assistance: 'Nereikalinga', status: 'Išspręsta' },
      { property: 'Vilnius – Namas 12', type: 'Aptiktas vanduo', location: 'Vonios kambarys', detected: '09:15', ack: '09:17', assistance: 'Susisiekta', status: 'Vykdoma' },
      { property: 'Talinas – Butas 7A', type: 'Aptiktas vanduo', location: 'Ūkinė patalpa', detected: '10:03', ack: '—', assistance: '—', status: 'Naujas' },
      { property: 'Kaunas – Kotedžas 3', type: 'Aptiktas vanduo', location: 'Po kriaukle', detected: '10:28', ack: '10:31', assistance: 'Išsiųsta', status: 'Pagalba pasitelkta' },
      { property: 'Ryga – Butas 22C', type: 'Aptiktas vanduo', location: 'Katilinė', detected: '11:05', ack: '11:06', assistance: 'Nereikalinga', status: 'Patvirtinta' },
    ],
    detectedShort: 'Aptikta',
    note: 'Visi rodomi skaičiai yra konceptualūs sąsajos pavyzdžiai, o ne realūs veiklos duomenys.',
  },
  portfolio: {
    label: 'Portfelio analitika',
    h2: 'Paverskite incidentus portfelio analitika.',
    sub: 'E2 Insurance gali padėti draudikams suprasti prevencijos rezultatus visame portfelyje — ne tik spręsti pavienius incidentus.',
    indicators: [
      'Apsaugotų būstų skaičius',
      'Aptiktų incidentų skaičius',
      'Incidentų dažnis',
      'Vidutinis patvirtinimo laikas',
      'Vidutinis išsprendimo laikas',
      'Pasikartojantys incidentai',
      'Vietos su pasikartojančiais įvykiais',
      'Neišspręsti įspėjimai',
      'Apsaugos prieinamumas',
      'Prevencijos rezultatai laikui bėgant',
    ],
    highlight: 'Pavieniai įspėjimai išsprendžia incidentus. Portfelio analitika padeda draudikams tobulinti prevencijos strategiją.',
  },
  assist: {
    label: 'Pasirinktinai — intervencijos partneriams',
    h2: 'Sujunkite pagalbą tiesiogiai su incidentu.',
    p1: 'gali suteikti pagalbos operatoriams ar paslaugų teikėjams sutelktą vaizdą į incidentus, kuriems reikia įsikišimo.',
    note: 'Draudikai renkasi savo veiklos modelį — E2 nereikalauja, kad draudikai naudotų E2 Assist.',
    panelTitle: 'E2 Assist — galimos funkcijos',
    functions: [
      'Priskirti incidentai',
      'Informacija apie būstą',
      'Incidento vieta',
      'Aptikimo laikas',
      'Kliento būsena',
      'Reikalingi veiksmai',
      'Intervencijos patvirtinimas',
      'Incidento uždarymas',
      'Pastabos',
    ],
  },
  platform: {
    label: 'Platforma',
    h2: 'Viena prevencijos platforma. Trys veiklos patirtys.',
    items: [
      { name: 'E2 Home', who: 'Draudėjui' },
      { name: 'E2 Insurance Control Center', who: 'Draudikui' },
      { name: 'E2 Assist', who: 'Pagalbos ir intervencijos partneriams' },
    ],
    statement: 'E2 sujungia aptikimą, kliento reakciją, draudimo operacijas ir pagalbą į vieną išmatuojamą incidentų darbo eigą.',
  },
  workflow: {
    label: 'Darbo eiga',
    h2: 'Nuo aptikimo iki išsprendimo.',
    steps: [
      'Aptiktas vanduo',
      'Klientas informuotas',
      'Klientas patvirtina',
      'Prireikus informuojama pagalba',
      'Imtasi veiksmų',
      'Incidentas išspręstas',
      'Įvykis užregistruotas',
    ],
    note: 'E2 Insurance gali pritaikyti pranešimų ir eskalavimo taisykles kiekvieno draudiko veiklos modeliui.',
  },
  fits: {
    label: 'Lanksti veikla',
    h2: 'Jūsų draudimo darbo eiga. Jūsų taisyklės.',
    sub: 'E2 neverčia draudikų laikytis konkretaus veiklos modelio. Incidentas gali paleisti skirtingas darbo eigas.',
    models: [
      { title: 'Pirmiausia klientas', desc: 'Nedelsiant įspėkite draudėją ir eskaluokite tik tada, jei nėra atsakymo.' },
      { title: 'Pirmiausia pagalba', desc: 'Informuokite pagalbos centrą tuo pačiu metu kaip ir klientą.' },
      { title: 'Eskalavimas paslaugų teikėjui', desc: 'Siųskite pasirinktus incidentus patvirtintam intervencijos partneriui.' },
      { title: 'Draudiko kontroliuojama', desc: 'Nukreipkite incidentus per paties draudiko operacinę aplinką.' },
    ],
    highlight: 'E2 prisitaiko prie draudiko — o ne atvirkščiai.',
  },
  opportunity: {
    label: 'Produkto galimybė',
    h2: 'Padarykite prevenciją draudimo produkto dalimi.',
    modelLabel: 'Modelis',
    models: [
      { title: 'Įtraukta apsauga', desc: 'Siūlykite E2 Insurance kaip pasirinktų būsto draudimo polisų dalį.' },
      { title: 'Premium apsauga', desc: 'Siūlykite ją kaip papildomą prevencijos paslaugą.' },
      { title: 'Didelės rizikos būstai', desc: 'Diegkite apsaugą ten, kur galimas vandens žalos mastas ypač didelis.' },
      { title: 'Portfelio prevencija', desc: 'Naudokite E2 Insurance pasirinktuose klientų segmentuose, kad sumažintumėte bendrą riziką.' },
      { title: 'White-label paslauga', desc: 'Teikite paslaugą su paties draudiko prekės ženklu.' },
    ],
  },
  calculator: {
    label: 'Scenarijų modeliavimas',
    h2: 'Ištirkite galimą prevencijos ekonomiką.',
    sub: 'Įveskite savo portfelio prielaidas iliustraciniam scenarijui sumodeliuoti. Jokios E2 prielaidos nėra iš anksto pateiktos kaip faktai.',
    inputsTitle: 'Jūsų prielaidos',
    properties: 'Apdraustų būstų skaičius',
    frequency: 'Metinis vandens žalos atvejų dažnis (%)',
    avgCost: 'Vidutinė vieno vandens žalos atvejo kaina (€)',
    reduction: 'Numatomas vidutinio žalos masto sumažėjimas (%)',
    reductionNote: 'Jūsų pačių prielaida — ne E2 veiklos rezultatų teiginys.',
    resultsTag: 'Iliustracinis scenarijus pagal jūsų įvestį',
    claims: 'Numatomi metiniai vandens žalos atvejai',
    exposure: 'Numatoma metinė vandens žalos rizika',
    avoided: 'Galimai išvengti nuostoliai pagal jūsų prielaidas',
    disclaimer: 'Šis skaičiuoklis skirtas tik scenarijų modeliavimui. Rezultatai grindžiami vien vartotojo įvestomis prielaidomis ir negarantuoja santaupų ar E2 veiklos rezultatų.',
  },
  businessCase: {
    label: 'Verslo pagrindimas',
    h2: 'Lygtis paprasta.',
    statement: 'Kiek žalos galima išvengti anksčiau aptikus incidentą?',
    support: 'Draudikui net santykinai nedidelis vidutinio žalos masto sumažėjimas gali sukurti reikšmingą vertę, pritaikius jį dideliam apdraustam portfeliui.',
    highlight: 'E2 Insurance sukurtas tam, kad prevencija taptų išmatuojama.',
  },
  trust: {
    label: 'Patikimumas ir valdymas',
    h2: 'Sukurta patikimoms draudimo operacijoms.',
    items: [
      { title: 'Saugi prieiga', desc: 'Rolėmis pagrįsta prieiga prie operatyvinės informacijos.' },
      { title: 'Incidentų atsekamumas', desc: 'Įvykiai ir operatyviniai veiksmai gali būti registruojami per visą incidento gyvavimo ciklą.' },
      { title: 'Duomenų apsauga', desc: 'Sukurta atsižvelgiant į duomenų apsaugą ir kontroliuojamą prieigą.' },
      { title: 'Konfigūruojamas duomenų saugojimas', desc: 'Saugojimo politikos gali būti konfigūruojamos pagal veiklos ir reguliavimo reikalavimus.' },
      { title: 'Veiklos matomumas', desc: 'Draudikai gali stebėti paslaugos ir apsaugos prieinamumą.' },
    ],
  },
  adapt: {
    label: 'Pritaikomumas',
    h2: 'Technologija turi prisitaikyti prie draudimo — o ne atvirkščiai.',
    sub: 'E2 Insurance gali veikti kaip nepriklausoma prevencijos paslauga arba integruotis į esamas draudimo ir pagalbos aplinkas.',
    caps: [
      'Klientų pranešimų taisyklės',
      'Pagalbos procesai',
      'Eskalavimo procedūros',
      'Žalų darbo eigos',
      'Draudiko prekės ženklas',
      'Portfelio segmentavimas',
      'Veiklos ataskaitos',
      'Integracija su esamomis sistemomis',
    ],
  },
  whiteLabel: {
    label: 'Diegimo modelis',
    h2: 'Jūsų prekės ženklas. Jūsų santykis su klientu.',
    p: 'E2 Insurance gali palaikyti white-label diegimo modelį: draudikas gali siūlyti prevencijos paslaugą su savo prekės ženklu, o E2 užtikrina pagrindinę prevencijos infrastruktūrą.',
    panelTitle: 'Konfigūruojami elementai',
    elements: ['Prekės ženklas', 'Komunikacija su klientais', 'Pranešimų darbo eigos', 'Pagalbos procesai', 'Operacinės sąsajos'],
  },
  faq: {
    label: 'DUK',
    h2: 'Vandens nuotėkių aptikimas draudimui — dažniausi klausimai.',
    items: [
      { q: 'Kas yra vandens nuotėkių aptikimas draudimui?', a: 'Vandens nuotėkių aptikimas draudimui naudoja sujungtą aptikimą, kad vandens incidentai būtų identifikuoti kuo anksčiau. Užuot laukus, kol draudėjas pastebės žalą, sistema įspėja klientus, draudikus ar pagalbos teikėjus vos aptikus vandenį, kad kas nors galėtų sureaguoti, kol žala netapo didesnė.' },
      { q: 'Kaip ankstyvas vandens nuotėkių aptikimas gali padėti draudikams?', a: 'Ankstesnis aptikimas sukuria laiko įsikišti. Šis laikas gali reikšti greitesnę reakciją, galimai mažesnį žalos mastą, geresnę klientų patirtį ir struktūruotus incidentų duomenis. Draudikai mato, kaip incidentai vystosi ir kaip greitai jie išsprendžiami visame apdraustame portfelyje.' },
      { q: 'Kas gauna vandens nuotėkio įspėjimą?', a: 'Pranešimų ir eskalavimo taisyklės konfigūruojamos pagal draudiko veiklos modelį. Įspėjimai gali pirmiausia pasiekti draudėją, lygiagrečiai pagalbos centrą, patvirtintą intervencijos partnerį arba keliauti per paties draudiko operacinę aplinką.' },
      { q: 'Ar klientas turi stebėti sistemą?', a: 'Ne. Paslauga sukurta veikti automatiškai fone. Draudėjui nereikia tikrinti skydelių ar stebėti įrangos. Kai kažkas įvyksta, klientas gauna paprastą, aiškų įspėjimą su rekomenduojamais žingsniais.' },
      { q: 'Ar E2 Insurance gali integruotis su esama draudimo programėle?', a: 'E2 Insurance sukurtas palaikyti integraciją su esamomis draudimo ir pagalbos aplinkomis. Draudikai gali įtraukti prevencijos įspėjimus ir incidentų duomenis į savo klientų ir operacines darbo eigas.' },
      { q: 'Ar E2 Insurance galima naudoti su savo prekės ženklu (white-label)?', a: 'Taip. Platforma gali palaikyti draudiko prekės ženklo diegimo modelius, kai draudikas siūlo prevencijos paslaugą su savo prekės ženklu, o E2 užtikrina pagrindinę prevencijos infrastruktūrą.' },
      { q: 'Ar draudikai gali stebėti kelis būstus?', a: 'Taip. E2 Insurance Control Center sukurtas suteikti portfelio lygio veiklos matomumą: apsaugoti būstai, aktyvūs incidentai, reagavimo laikai ir išsprendimo būsena visoje apdraustoje bazėje.' },
      { q: 'Kokia informacija registruojama incidento metu?', a: 'Kiekvienas incidentas gali sukurti išsamią laiko juostą: kada aptiktas vanduo, kada klientas informuotas, kada įspėjimas patvirtintas, kokių veiksmų imtasi, ar dalyvavo pagalba ir kada incidentas išspręstas.' },
    ],
  },
  finalCta: {
    line1: 'Draudimas turėtų ne tik mokėti už žalą.',
    line2: 'Jis turėtų padėti jos išvengti.',
    descriptor: 'Sujungta rizikos prevencija moderniems draudikams.',
    cta: 'Susisiekite su mumis',
  },
  contact: {
    label: 'Kontaktai',
    h2: 'Pakalbėkime apie prevenciją draudime.',
    sub: 'Norite sužinoti, kaip sujungta prevencija galėtų sustiprinti jūsų draudimo portfelį? Aptarkime tai.',
  },
};

export const e2ee = {
  meta: {
    title: 'Veelekete tuvastamine kindlustusele | E2 Insurance',
    description: 'E2 Insurance aitab kindlustusandjatel veelekkeid varem tuvastada, kiiremini sekkuda ja vähendada veekahjude ulatust ühendatud riskiennetuse abil.',
    twitterDescription: 'Ühendatud riskiennetus modernsetele kindlustusandjatele. Tuvastage varem, reageerige kiiremini, vähendage kahjude ulatust.',
  },
  hero: {
    badge: 'E2 Insurance — Ühendatud riskiennetus',
    h1: 'Ennetage veekahju enne, kui sellest saab suur kahjunõue.',
    sub: 'E2 Insurance aitab kindlustusandjatel veelekkeid varakult tuvastada, õigeid inimesi kohe teavitada ja vähendada veekahjujuhtumite mõju.',
    supporting: 'Kahjukäsitlusest aktiivse riskiennetuseni.',
    ctaPrimary: 'Tutvuge E2 Insurance’iga',
    ctaSecondary: 'Võtke meiega ühendust',
    trustLine: 'Loodud kindlustusandjatele, abiteenuse operaatoritele ja modernsetele kodukindlustustoodetele.',
    liveLabel: 'Aktiivne juhtum',
    resolved: 'LAHENDATUD',
    incidentTitle: 'Vesi tuvastatud — Köök',
    incidentLoc: 'Riia · Korter 4B',
    steps: [
      ['02:14', 'Vesi tuvastatud köögivalamu all'],
      ['02:15', 'Klienti teavitatud'],
      ['02:17', 'Klient kinnitas hoiatuse'],
      ['02:46', 'Juhtum lahendatud'],
    ],
    tta: 'Kinnitamise aeg',
    ttaVal: '3 min',
    ttr: 'Lahendamise aeg',
    ttrVal: '32 min',
  },
  problem: {
    label: 'Probleem',
    h2: 'Veekahju muutub kalliks, kui keegi ei tea, et see toimub.',
    p1: 'Väike leke võib jääda märkamatuks tundideks või päevadeks. Selleks ajaks, kui kindlustusvõtja selle avastab, võib kahju juba hõlmata põrandaid, seinu, mööblit, naaberkinnistuid ja märkimisväärseid taastamiskulusid.',
    p2: 'Traditsiooniline kindlustus algab siis, kui kahjust teatatakse.',
    highlight: 'E2 Insurance algab siis, kui juhtum algab.',
    statement: 'Kõige kallim leke on see, millest keegi ei tea.',
  },
  compare: {
    label: 'Erinevus',
    h2: 'Aeg muudab tulemust.',
    withoutTitle: 'Ilma varajase tuvastamiseta',
    withoutSteps: ['Leke algab', 'Leke jääb märkamata', 'Veekahju levib', 'Klient avastab kahju', 'Kahjust teatatakse', 'Taastamistööd algavad'],
    withoutNote: 'Enne kui keegi reageerib, võivad mööduda tunnid või päevad.',
    withTitle: 'Koos E2 Insurance’iga',
    withSteps: ['Leke algab', 'Vesi tuvastatud', 'Klienti hoiatatud', 'Juhtum kinnitatud', 'Tegutsetud', 'Kahju võimalik piirata'],
    withNote: 'Minutid tuvastamisest tegutsemiseni.',
    conclusion: 'E2 muudab aja riski vähendamise tööriistaks.',
  },
  value: {
    label: 'Kuidas see töötab',
    h2: 'Tuvastage varem. Reageerige kiiremini. Vähendage kahju.',
    stepLabel: 'Samm',
    steps: [
      { title: 'Tuvasta', desc: 'Vesi tuvastatakse kohe, kui juhtum toimub.' },
      { title: 'Hoiata', desc: 'Õigeid inimesi teavitatakse automaatselt.' },
      { title: 'Reageeri', desc: 'Kindlustusvõtja, abiteenuse pakkuja või hooldusmeeskond saab kiiresti sekkuda.' },
      { title: 'Dokumenteeri', desc: 'Iga juhtumi ja tegevuse saab salvestada operatiivseks jälgimiseks ja analüüsiks.' },
    ],
  },
  metrics: {
    label: 'Mõõdetav ennetus',
    h2: 'Mõõtke ennetust reageerimisaja kaudu.',
    items: [
      { label: 'Tuvastamise aeg', desc: 'Kui kiiresti juhtum tuvastatakse.' },
      { label: 'Kinnitamise aeg', desc: 'Kui kiiresti keegi hoiatuse kinnitab.' },
      { label: 'Lahendamise aeg', desc: 'Kui kiiresti olukord kontrolli alla saadakse.' },
    ],
    statement: 'Ennetus muutub mõõdetavaks, kui igal juhtumil on ajajoon.',
  },
  gains: {
    label: 'Väärtus kindlustusele',
    h2: 'Muutke ennetus mõõdetavaks kindlustusväärtuseks.',
    items: [
      { title: 'Vähendage kahjude ulatust', desc: 'Varasem tuvastamine võib piirata kahju ulatust enne sekkumist.' },
      { title: 'Lühendage reageerimisaega', desc: 'Hoiatused genereeritakse automaatselt, mitte lootes, et keegi probleemi lõpuks avastab.' },
      { title: 'Parandage kliendikogemust', desc: 'Kindlustusandja aitab klientidel kahju ennetada, mitte ainult ei hüvita seda tagantjärele.' },
      { title: 'Looge kasutatavaid riskiandmeid', desc: 'Saage struktureeritud teavet juhtumite, reageerimisaegade ja ennetustulemuste kohta.' },
      { title: 'Tugevdage klientide lojaalsust', desc: 'Riskiennetusteenused võivad saada kodukindlustustoodete käegakatsutavaks eeliseks.' },
      { title: 'Eristage oma tooteid', desc: 'Pakkuge klientidele proaktiivset teenust, mis ületab traditsioonilise kindlustuskaitse ja hinna.' },
    ],
  },
  incident: {
    label: 'Juhtumite jälgitavus',
    h2: 'Juhtumist lahenduseni — iga sekund on nähtav.',
    sub: 'Iga juhtum loob tervikliku, ajatemplitega sündmuste ajaloo — esimesest tuvastamisest lõpliku lahenduseni.',
    cardTitle: 'Vesi tuvastatud — Köök',
    cardId: 'Juhtum #2481 · Näidissündmus',
    status: 'Lahendatud',
    events: [
      ['02:14', 'Vesi tuvastatud köögivalamu all'],
      ['02:15', 'Klienti teavitatud'],
      ['02:17', 'Klient kinnitas hoiatuse'],
      ['02:21', 'Abiteenusega ühendust võetud'],
      ['02:29', 'Tegevus alustatud'],
      ['02:46', 'Juhtum lahendatud'],
    ],
    tta: 'Kinnitamise aeg',
    ttaVal: '3 min',
    ttr: 'Lahendamise aeg',
    ttrVal: '32 min',
    note: 'Kontseptuaalne näide illustratsiooniks — mitte tegelik tegevusstatistika.',
  },
  customer: {
    label: 'Kliendikogemus',
    h2: 'Kaitse ilma keerukuseta.',
    p1: 'E2 Insurance on loodud töötama automaatselt taustal. Kindlustusvõtja ei pea tehnilist infrastruktuuri mõistma ega jälgima.',
    p2: 'Kui midagi juhtub, saab klient lihtsa ja selge hoiatuse koos soovitatavate sammudega.',
    e2homeSub: 'Lihtne kaitse kindlustusvõtjale.',
    features: [
      'Kinnisvara kaitsestaatus',
      'Aktiivsed hoiatused',
      'Tuvastatud juhtumite asukoht',
      'Push-teavitused',
      'Juhtumi kinnitamine',
      'Lihtsad juhised',
      'Juhtumite ajalugu',
      'Ühendus abiteenusega',
      'Kinnitus, kui juhtum on lahendatud',
    ],
    highlight: 'Rakendus on olemas ühel põhjusel: aidata kliendil kiiresti tegutseda, kui midagi juhtub.',
    mockup: {
      homeStatus: 'Kodu staatus',
      protected: 'Kaitstud',
      alertTitle: 'Vesi tuvastatud',
      alertLoc: 'Köök · Valamu all · 14:32',
      recommended: 'Soovitatav tegevus',
      recommendedAction: 'Kontrollige piirkonda kohe.',
      btnCheck: 'Kontrollin',
      btnAssist: 'Võta ühendust abiga',
    },
  },
  control: {
    label: 'Kindlustusandjale',
    h2: 'Üks vaade kogu kindlustatud portfellile.',
    sub: 'E2 Insurance Control Center annab operatiivmeeskondadele reaalajas ülevaate igast kaitstud kinnisvarast ja igast aktiivsest juhtumist.',
    sampleTag: 'NÄIDISLIIDES — ILLUSTRATIIVSED VÄÄRTUSED',
    kpis: [
      { label: 'Kaitstud kinnisvarad', value: '12 482' },
      { label: 'Aktiivsed juhtumid', value: '7' },
      { label: 'Keskmine kinnitamise aeg', value: '2 min 18 s' },
      { label: 'Sel kuul lahendatud juhtumid', value: '164' },
    ],
    tableHeaders: ['Kinnisvara', 'Juhtumi tüüp', 'Asukoht', 'Tuvastatud', 'Kinnitatud', 'Abi', 'Staatus'],
    incidents: [
      { property: 'Riia – Korter 4B', type: 'Vesi tuvastatud', location: 'Köök', detected: '08:42', ack: '08:45', assistance: 'Pole vajalik', status: 'Lahendatud' },
      { property: 'Vilnius – Maja 12', type: 'Vesi tuvastatud', location: 'Vannituba', detected: '09:15', ack: '09:17', assistance: 'Ühendust võetud', status: 'Töös' },
      { property: 'Tallinn – Korter 7A', type: 'Vesi tuvastatud', location: 'Majapidamisruum', detected: '10:03', ack: '—', assistance: '—', status: 'Uus' },
      { property: 'Kaunas – Ridaelamu 3', type: 'Vesi tuvastatud', location: 'Valamu all', detected: '10:28', ack: '10:31', assistance: 'Välja saadetud', status: 'Abi kaasatud' },
      { property: 'Riia – Korter 22C', type: 'Vesi tuvastatud', location: 'Katlaruum', detected: '11:05', ack: '11:06', assistance: 'Pole vajalik', status: 'Kinnitatud' },
    ],
    detectedShort: 'Tuvastatud',
    note: 'Kõik kuvatud arvud on kontseptuaalsed liidese näited, mitte tegelikud tegevusandmed.',
  },
  portfolio: {
    label: 'Portfelli analüütika',
    h2: 'Muutke juhtumid portfelli analüütikaks.',
    sub: 'E2 Insurance aitab kindlustusandjatel mõista ennetuse tulemuslikkust kogu portfellis — mitte ainult lahendada üksikuid juhtumeid.',
    indicators: [
      'Kaitstud kinnisvarade arv',
      'Tuvastatud juhtumite arv',
      'Juhtumite sagedus',
      'Keskmine kinnitamise aeg',
      'Keskmine lahendamise aeg',
      'Korduvad juhtumid',
      'Korduvate sündmustega asukohad',
      'Lahendamata hoiatused',
      'Kaitse kättesaadavus',
      'Ennetuse tulemuslikkus ajas',
    ],
    highlight: 'Üksikud hoiatused lahendavad juhtumeid. Portfelli analüütika aitab kindlustusandjatel ennetusstrateegiat parandada.',
  },
  assist: {
    label: 'Valikuline — sekkumispartneritele',
    h2: 'Ühendage abiteenus otse juhtumiga.',
    p1: 'saab pakkuda abiteenuse operaatoritele või teenusepakkujatele fokuseeritud vaadet juhtumitele, mis vajavad sekkumist.',
    note: 'Kindlustusandjad valivad oma tegevusmudeli — E2 ei nõua kindlustusandjatelt E2 Assisti kasutamist.',
    panelTitle: 'E2 Assist — võimalikud funktsioonid',
    functions: [
      'Määratud juhtumid',
      'Kinnisvara teave',
      'Juhtumi asukoht',
      'Tuvastamise aeg',
      'Kliendi staatus',
      'Vajalikud tegevused',
      'Sekkumise kinnitamine',
      'Juhtumi sulgemine',
      'Märkmed',
    ],
  },
  platform: {
    label: 'Platvorm',
    h2: 'Üks ennetusplatvorm. Kolm töökogemust.',
    items: [
      { name: 'E2 Home', who: 'Kindlustusvõtjale' },
      { name: 'E2 Insurance Control Center', who: 'Kindlustusandjale' },
      { name: 'E2 Assist', who: 'Abiteenuse ja sekkumispartneritele' },
    ],
    statement: 'E2 ühendab tuvastamise, kliendi reageerimise, kindlustusoperatsioonid ja abiteenuse üheks mõõdetavaks juhtumite töövooks.',
  },
  workflow: {
    label: 'Töövoog',
    h2: 'Tuvastamisest lahenduseni.',
    steps: [
      'Vesi tuvastatud',
      'Klienti teavitatud',
      'Klient kinnitab',
      'Vajadusel teavitatakse abiteenust',
      'Tegutsetud',
      'Juhtum lahendatud',
      'Sündmus salvestatud',
    ],
    note: 'E2 Insurance saab kohandada teavitus- ja eskaleerimisreegleid iga kindlustusandja tegevusmudelile.',
  },
  fits: {
    label: 'Paindlik töökorraldus',
    h2: 'Teie kindlustuse töövoog. Teie reeglid.',
    sub: 'E2 ei sunni kindlustusandjaid kindlasse tegevusmudelisse. Juhtum võib käivitada erinevaid töövooge.',
    models: [
      { title: 'Klient esimesena', desc: 'Hoiatage kindlustusvõtjat kohe ja eskaleeruge ainult siis, kui vastust ei tule.' },
      { title: 'Abiteenus esimesena', desc: 'Teavitage abikeskust samal ajal kui klienti.' },
      { title: 'Eskaleerimine teenusepakkujale', desc: 'Saatke valitud juhtumid heakskiidetud sekkumispartnerile.' },
      { title: 'Kindlustusandja kontrolli all', desc: 'Suunake juhtumid läbi kindlustusandja enda töökeskkonna.' },
    ],
    highlight: 'E2 kohandub kindlustusandjaga — mitte vastupidi.',
  },
  opportunity: {
    label: 'Tootevõimalus',
    h2: 'Tehke ennetus kindlustustoote osaks.',
    modelLabel: 'Mudel',
    models: [
      { title: 'Kaasatud kaitse', desc: 'Pakkuge E2 Insurance’i valitud kodukindlustuspoliiside osana.' },
      { title: 'Premium-kaitse', desc: 'Pakkuge seda täiendava ennetusteenusena.' },
      { title: 'Kõrge riskiga kinnisvarad', desc: 'Paigaldage kaitse sinna, kus veekahju võimalik ulatus on eriti suur.' },
      { title: 'Portfelli ennetus', desc: 'Kasutage E2 Insurance’i valitud kliendisegmentides üldise riski vähendamiseks.' },
      { title: 'White-label teenus', desc: 'Osutage teenust kindlustusandja enda kaubamärgi all.' },
    ],
  },
  calculator: {
    label: 'Stsenaariumide modelleerimine',
    h2: 'Uurige ennetuse võimalikku majandust.',
    sub: 'Sisestage oma portfelli eeldused illustratiivse stsenaariumi modelleerimiseks. Ühtegi E2 eeldust pole faktidena ette laaditud.',
    inputsTitle: 'Teie eeldused',
    properties: 'Kindlustatud kinnisvarade arv',
    frequency: 'Aastane veekahjunõuete sagedus (%)',
    avgCost: 'Keskmine kulu ühe veekahjunõude kohta (€)',
    reduction: 'Eeldatav keskmise kahju ulatuse vähenemine (%)',
    reductionNote: 'Teie enda eeldus — mitte E2 tulemuslikkuse väide.',
    resultsTag: 'Illustratiivne stsenaarium teie sisendite põhjal',
    claims: 'Hinnangulised aastased veekahjunõuded',
    exposure: 'Hinnanguline aastane veekahju risk',
    avoided: 'Võimalik välditud kahju teie eelduste põhjal',
    disclaimer: 'See kalkulaator on mõeldud ainult stsenaariumide modelleerimiseks. Tulemused põhinevad täielikult kasutaja sisestatud eeldustel ega kujuta endast garanteeritud kokkuhoidu ega E2 tulemuslikkuse väiteid.',
  },
  businessCase: {
    label: 'Ärijuhtum',
    h2: 'Võrrand on lihtne.',
    statement: 'Kui palju kahju saab ära hoida, tuvastades juhtumi varem?',
    support: 'Kindlustusandja jaoks võib isegi suhteliselt väike keskmise kahju ulatuse vähenemine luua märkimisväärset väärtust, kui seda rakendada suurele kindlustatud portfellile.',
    highlight: 'E2 Insurance on loodud selleks, et muuta ennetus mõõdetavaks.',
  },
  trust: {
    label: 'Usaldusväärsus ja haldus',
    h2: 'Loodud usaldusväärseteks kindlustusoperatsioonideks.',
    items: [
      { title: 'Turvaline juurdepääs', desc: 'Rollipõhine juurdepääs operatiivteabele.' },
      { title: 'Juhtumite jälgitavus', desc: 'Sündmusi ja operatiivtegevusi saab salvestada kogu juhtumi elutsükli jooksul.' },
      { title: 'Andmekaitse', desc: 'Loodud andmekaitset ja kontrollitud juurdepääsu silmas pidades.' },
      { title: 'Seadistatav andmete säilitamine', desc: 'Säilituspoliitikaid saab seadistada vastavalt tegevus- ja regulatiivsetele nõuetele.' },
      { title: 'Tegevuse nähtavus', desc: 'Kindlustusandjad saavad jälgida teenuse ja kaitse kättesaadavust.' },
    ],
  },
  adapt: {
    label: 'Kohandatavus',
    h2: 'Tehnoloogia peab kohanduma kindlustusega — mitte vastupidi.',
    sub: 'E2 Insurance saab töötada iseseisva ennetusteenusena või integreeruda olemasolevate kindlustus- ja abiteenuse keskkondadega.',
    caps: [
      'Klienditeavituste reeglid',
      'Abiteenuse protsessid',
      'Eskaleerimisprotseduurid',
      'Kahjukäsitluse töövood',
      'Kindlustusandja bränding',
      'Portfelli segmenteerimine',
      'Tegevusaruandlus',
      'Integratsioon olemasolevate süsteemidega',
    ],
  },
  whiteLabel: {
    label: 'Juurutusmudel',
    h2: 'Teie bränd. Teie kliendisuhe.',
    p: 'E2 Insurance saab toetada white-label juurutusmudelit: kindlustusandja saab pakkuda ennetusteenust oma kaubamärgi all, samal ajal kui E2 tagab aluseks oleva ennetusinfrastruktuuri.',
    panelTitle: 'Seadistatavad elemendid',
    elements: ['Bränding', 'Kliendisuhtlus', 'Teavituste töövood', 'Abiteenuse protsessid', 'Operatiivliidesed'],
  },
  faq: {
    label: 'KKK',
    h2: 'Veelekete tuvastamine kindlustusele — korduma kippuvad küsimused.',
    items: [
      { q: 'Mis on veelekete tuvastamine kindlustusele?', a: 'Veelekete tuvastamine kindlustusele kasutab ühendatud tuvastamist, et veejuhtumid võimalikult vara kindlaks teha. Selle asemel, et oodata, kuni kindlustusvõtja kahju avastab, hoiatab süsteem kliente, kindlustusandjaid või abiteenuse pakkujaid kohe, kui vesi on tuvastatud, et keegi saaks reageerida enne, kui kahju süveneb.' },
      { q: 'Kuidas saab varajane veelekete tuvastamine kindlustusandjaid aidata?', a: 'Varasem tuvastamine loob aega sekkumiseks. See aeg võib tähendada kiiremat reageerimist, võimalikku väiksemat kahju ulatust, paremat kliendikogemust ja struktureeritud juhtumiandmeid. Kindlustusandjad näevad, kuidas juhtumid arenevad ja kui kiiresti need kogu kindlustatud portfellis lahendatakse.' },
      { q: 'Kes saab veelekke hoiatuse?', a: 'Teavitus- ja eskaleerimisreeglid on seadistatavad vastavalt kindlustusandja tegevusmudelile. Hoiatused võivad jõuda esmalt kindlustusvõtjani, paralleelselt abikeskusesse, heakskiidetud sekkumispartnerile või liikuda läbi kindlustusandja enda töökeskkonna.' },
      { q: 'Kas klient peab süsteemi jälgima?', a: 'Ei. Teenus on loodud töötama automaatselt taustal. Kindlustusvõtja ei pea töölaudu kontrollima ega seadmeid jälgima. Kui midagi juhtub, saab klient lihtsa ja selge hoiatuse koos soovitatavate sammudega.' },
      { q: 'Kas E2 Insurance saab integreeruda olemasoleva kindlustusrakendusega?', a: 'E2 Insurance on loodud toetama integratsiooni olemasolevate kindlustus- ja abiteenuse keskkondadega. Kindlustusandjad saavad kaasata ennetushoiatused ja juhtumiandmed oma kliendi- ja töövoogudesse.' },
      { q: 'Kas E2 Insurance’i saab kasutada oma kaubamärgi all (white-label)?', a: 'Jah. Platvorm saab toetada kindlustusandja brändiga juurutusmudeleid, kus kindlustusandja pakub ennetusteenust oma kaubamärgi all, samal ajal kui E2 tagab aluseks oleva ennetusinfrastruktuuri.' },
      { q: 'Kas kindlustusandjad saavad jälgida mitut kinnisvara?', a: 'Jah. E2 Insurance Control Center on loodud pakkuma portfelli tasemel tegevusülevaadet: kaitstud kinnisvarad, aktiivsed juhtumid, reageerimisajad ja lahendamise staatus kogu kindlustatud baasis.' },
      { q: 'Milline teave juhtumi ajal salvestatakse?', a: 'Iga juhtum võib luua tervikliku ajajoone: millal vesi tuvastati, millal klienti teavitati, millal hoiatus kinnitati, milliseid tegevusi tehti, kas abiteenus oli kaasatud ja millal juhtum lahendati.' },
    ],
  },
  finalCta: {
    line1: 'Kindlustus ei peaks ainult kahju eest maksma.',
    line2: 'See peaks aitama seda ennetada.',
    descriptor: 'Ühendatud riskiennetus modernsetele kindlustusandjatele.',
    cta: 'Võtke meiega ühendust',
  },
  contact: {
    label: 'Kontakt',
    h2: 'Räägime ennetusest kindlustuses.',
    sub: 'Kas soovite uurida, kuidas ühendatud ennetus võiks teie kindlustusportfelli toetada? Arutame seda.',
  },
};
